import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { filterSuccessResult, injectQuery } from '@ngneat/query';
import { map } from 'rxjs';

import { IBaseResponse, IPasses, IMyPassResponse } from '../types';

import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class PassesService {
  private readonly storageService = inject(StorageService);
  private readonly http = inject(HttpClient);
  private readonly query = injectQuery();

  getTickets() {
    const organization = this.storageService.storage().organization;
    const url = `booking/tickets/${organization}`;

    return this.query({
      queryKey: [url],
      queryFn: () => {
        return this.http.get<IBaseResponse<IPasses>>(url, { params: { limit: 999 } });
      },
    }).result$.pipe(
      filterSuccessResult(),
      map(({ data }) => data),
    );
  }

  getMyTickets() {
    const organization = this.storageService.storage().organization;
    const url = `tickets/${organization}`;

    return this.query({
      queryKey: [url],
      queryFn: () => {
        return this.http.get<IMyPassResponse>(url, { params: { limit: 999 } });
      },
    }).result$.pipe(
      filterSuccessResult(),
      map(({ data }) => data),
    );
  }
}
